import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
import { PALETTES } from "./palettes";
import { IMAGE_LOADING, IMAGE_DECODING, IMAGE_FETCHPRIORITY } from "./image";
import PropTypes from 'prop-types';
export var PICTURE_PROP_TYPES = {
  role: PropTypes.string,
  alt: PropTypes.string,
  src: PropTypes.string.isRequired,
  loading: PropTypes.oneOf(Object.values(IMAGE_LOADING)),
  decoding: PropTypes.oneOf(Object.values(IMAGE_DECODING)),
  fetchpriority: PropTypes.oneOf(Object.values(IMAGE_FETCHPRIORITY))
};
export var IMAGE_PROP_TYPES = {
  url: PropTypes.string,
  description: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  alt: PropTypes.string,
  contentType: PropTypes.string,
  loading: PropTypes.oneOf(Object.values(IMAGE_LOADING)),
  decoding: PropTypes.oneOf(Object.values(IMAGE_DECODING)),
  fetchpriority: PropTypes.oneOf(Object.values(IMAGE_FETCHPRIORITY))
};
export var AUDIO_PROP_TYPES = PropTypes.shape({
  url: PropTypes.string,
  title: PropTypes.string
});
export var QUOTE_CONTENT_PROP_TYPES = {
  author: PropTypes.string,
  position: PropTypes.string,
  avatar: PropTypes.shape(IMAGE_PROP_TYPES),
  text: PropTypes.string,
  markdownText: PropTypes.string,
  audio: AUDIO_PROP_TYPES,
  tweetable: PropTypes.bool,
  hashtags: PropTypes.arrayOf(PropTypes.string),
  center: PropTypes.bool
};
export var QUOTE_PROP_TYPES = {
  content: PropTypes.shape(QUOTE_CONTENT_PROP_TYPES),
  color: PropTypes.string,
  disableLazyLoad: PropTypes.bool,
  currentUrl: PropTypes.string,
  center: PropTypes.bool
};
export var USER_PROP_TYPE = PropTypes.shape({
  email: PropTypes.string,
  name: PropTypes.string,
  role: PropTypes.string
});
export var childrenPropType = PropTypes.node;
export var LOCALE = {
  EN: 'en',
  ES: 'es'
};
export var UPCOMING_LOCALE = {
  DE: 'de',
  FR: 'fr'
};
export var ALL_LOCALES = _objectSpread(_objectSpread({}, LOCALE), UPCOMING_LOCALE);
export var DEFAULT_LOCALE = LOCALE.EN;
export var localesPropType = PropTypes.oneOf(Object.values(LOCALE));
export var upcomingLocalesPropType = PropTypes.oneOf(Object.values(UPCOMING_LOCALE));
export var allLocalesPropType = PropTypes.oneOf(Object.values(ALL_LOCALES));
export var refPropType = PropTypes.oneOfType([PropTypes.func, PropTypes.shape({
  current: PropTypes.any
})]);
export var palettePropType = PropTypes.oneOf(PALETTES);
export var BREAKPOINT_CONFIG_PROP_TYPE = {
  base: PropTypes.any,
  xs: PropTypes.any,
  sm: PropTypes.any,
  md: PropTypes.any,
  lg: PropTypes.any
};